const isPastDate = (dateString) => {
    const inputDate = new Date(dateString);
    const now = new Date();
    
    return inputDate.getTime() < now.getTime();
}

export default isPastDate;
